module.exports = __webpack_public_path__ + "img/vertical_3_2_8011.26f5f5d6.png";